import React, { useMemo } from "react";

import { TextAuxiliary } from "../TextAuxiliary/TextAuxiliary.component";
import {
  validateHasLowercase,
  validateHasNumber,
  validateHasUppercase,
  validateMinLength,
  validateSpecialCharacters,
} from "../../Utils";

interface TextProps {
  value: string;
  valueConfirm?: string;
  disabled?: boolean;
}

export const TextValidations: React.FC<TextProps> = ({
  value,
  valueConfirm,
  disabled = false,
}) => {
  const passwordHasUppercaseAndLowercase = useMemo(
    () => validateHasUppercase(value) && validateHasLowercase(value),
    [value]
  );

  const passwordHasNumber = useMemo(() => validateHasNumber(value), [value]);

  const passwordHasMinLength = useMemo(
    () => validateMinLength(value, 8),
    [value]
  );

  const passwordHasSpecialCaracter = useMemo(
    () => validateSpecialCharacters(value),
    [value]
  );

  const passwordEqualPasswords = useMemo(
    () => value && valueConfirm && value === valueConfirm,
    [value, valueConfirm]
  );

  const capitalAndSmallLetter = useMemo(
    () => ({
      text: "Letras maiúsculas e minúsculas",
      isValid: passwordHasUppercaseAndLowercase,
    }),
    [passwordHasUppercaseAndLowercase]
  );

  const number = useMemo(() => {
    return {
      text: "Numeral",
      isValid: passwordHasNumber,
    };
  }, [passwordHasNumber]);

  const minimumCharacters = useMemo(
    () => ({
      text: "8 caracteres",
      isValid: passwordHasMinLength,
    }),
    [passwordHasMinLength]
  );

  const specialCaracter = useMemo(
    () => ({
      text: "Caractere especial",
      isValid: passwordHasSpecialCaracter,
    }),
    [passwordHasSpecialCaracter]
  );

  const equalPasswords = useMemo(
    () => ({
      text: "Senhas iguais",
      isValid: passwordEqualPasswords || false,
    }),
    [passwordEqualPasswords]
  );

  return (
    <div>
      <TextAuxiliary disabled={disabled} {...capitalAndSmallLetter} />
      <TextAuxiliary disabled={disabled} {...number} />
      <TextAuxiliary disabled={disabled} {...specialCaracter} />
      <TextAuxiliary disabled={disabled} {...minimumCharacters} />
      {valueConfirm !== undefined && (
        <TextAuxiliary disabled={disabled} {...equalPasswords} />
      )}
    </div>
  );
};
